import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../constants/common'
import { toFileWithCorrectIdKey } from '../../File'
import {
  FilesPreviewGallery,
  useFilePreviewGallery,
} from '../../FilesPreviewGallery'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowActions,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../Table'
import { toMultiListFiles } from '../DocFlow.utils.files'
import { DocFlowCombiningFieldName } from '../DocFlowCombining'

import { ROW_ACTIONS_CONFIG } from './DocFlowCombiningTableRow.constants'
import { renderCell } from './DocFlowCombiningTableRow.utils'

import * as styles from './DocFlowCombiningTableRow.module.css'

function DocFlowCombiningTableRow({
  Actions = TableRowActions,
  actionLeft,
  actionsColumnWidth,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  hideCheckbox,
  isLoading,
  isResizing,
  isSelected,
  isShort,
  item,
  phaseDisabled,
  resizingColumn,
  scrollRef,
  showCellBorder,
  onCombinedDocument,
  ...restProps
}) {
  const { t } = useTranslation()

  const {
    handleCallAction,
    handleClick,
    handleMouseEnter,
    handleMouseLeave,
    handleSelect,
  } = useTableRowActions({ item, ...restProps }, ROW_ACTIONS_CONFIG)

  const previewFiles = [
    ...[item[DocFlowCombiningFieldName.FinalFile] || EMPTY_LIST],
    ...item[DocFlowCombiningFieldName.Uploading].map(item =>
      toFileWithCorrectIdKey(item)
    ),
  ]

  const { activeFileIndex, handleClickFile, handleCloseFilePreview } =
    useFilePreviewGallery({
      files: previewFiles,
    })

  const uploadingFiles = toMultiListFiles(item.uploading, t)

  function handleCombinedDocument(value) {
    onCombinedDocument(item, value)
  }

  const className = useTableRowModClassName({
    className: styles.DocFlowCombiningTableRow,
    isSelected,
  })

  const qaProps = getTableRowQaProps()

  return (
    <>
      <div
        {...qaProps}
        className={className}
        onClick={handleClick}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {Actions ? (
          <Actions
            disabled={phaseDisabled || hideCheckbox}
            selected={isSelected}
            width={actionsColumnWidth}
            onChange={handleSelect}
          />
        ) : null}
        {columns.map(column => (
          <Fragment key={column.name}>
            {renderCell({
              isActive: column.name === resizingColumn,
              isLoading,
              isResizing,
              isShort,
              item,
              name: column.name,
              phaseDisabled,
              scrollRef,
              showCellBorder,
              uploadingFiles,
              width: column.width,
              onClickFile: handleClickFile,
              onCombinedDocument: handleCombinedDocument,
            })}
          </Fragment>
        ))}
        <TableCellFreeSpaceFiller width={emptyColumnSize} />
        {getActions?.(item).length > 0 && !phaseDisabled ? (
          <TableRowContextActions
            actionLeft={actionLeft}
            focusedRow={focusedRow}
            getActions={getActions}
            item={item}
            onCallAction={handleCallAction}
          />
        ) : null}
      </div>
      <FilesPreviewGallery
        files={previewFiles}
        initActive={activeFileIndex}
        onClose={handleCloseFilePreview}
      />
    </>
  )
}

export default DocFlowCombiningTableRow
